<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading && generatedDocsResponse" class="flex flex-col">

    <!-- HEADER INTERNO -->
    <div class="bg-white rounded-lg border border-gray-200 p-3 sm:p-4 mb-4 sm:mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 flex-shrink-0">
        <div class="flex items-center gap-2 sm:gap-4">
            <fa-icon [icon]="faCircleCheck" class="text-green-500 text-3xl sm:text-4xl"></fa-icon>
            <div class="flex flex-col">
                <span class="text-base sm:text-lg font-semibold text-westetics-neutral-950">
                    Documentos Gerados
                </span>
                <span class="text-xs sm:text-sm text-westetics-neutral-600">
                    Faça download ou envie para assinatura
                </span>
            </div>
        </div>
        <div class="flex flex-wrap gap-2 sm:gap-3 w-full sm:w-auto">
            <button 
                (click)="sendAllDocuments()"
                [disabled]="!canSendDocuments()"
                class="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white rounded-lg transition-colors flex items-center justify-center gap-2"
                [ngClass]="canSendDocuments() ? 'bg-westetics-purple-800 hover:bg-westetics-purple-600' : 'bg-gray-300 cursor-not-allowed'"
            >
                <app-loading-spinner *ngIf="sentStatus === 'SENDING'" size="sm"></app-loading-spinner>
                <fa-icon *ngIf="sentStatus === 'SENT'" [icon]="faCheck"></fa-icon>
                <span class="hidden sm:inline">{{ getSendButtonText() }}</span>
                <span class="sm:hidden">{{ sentStatus === 'SENT' ? 'Enviado!' : 'Enviar' }}</span>
            </button>
            <button 
                *ngIf="treatmentPlanId"
                (click)="viewTreatmentPlan()"
                class="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors flex items-center justify-center gap-2"
            >
                <fa-icon [icon]="faFileAlt"></fa-icon>
                <span class="hidden sm:inline">Ver Plano de Tratamento</span>
                <span class="sm:hidden">Ver Plano</span>
            </button>
        </div>
    </div>

    <!-- CONTEÚDO -->
    <div class="flex-1 min-h-0">
        <div class="overflow-y-auto pb-4 sm:pb-6">

            <!-- LISTA DE DOCUMENTOS -->
            <div class="bg-white rounded-lg border border-gray-200">
                <div class="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                    <h3 class="text-sm sm:text-base font-semibold text-westetics-neutral-950 flex items-center gap-2">
                        <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600"></fa-icon>
                        Contratos gerados
                    </h3>
                </div>

                <div class="divide-y divide-gray-200">
                    <div *ngFor="let doc of generatedDocsResponse.documents_link_info; let i = index" 
                        class="px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 hover:bg-gray-50 transition-colors">
                        
                        <!-- Info do Documento -->
                        <div class="flex items-center gap-3 flex-1 min-w-0">
                            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-westetics-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                                <fa-icon [icon]="faFileAlt" class="text-westetics-purple-700 text-sm sm:text-base"></fa-icon>
                            </div>
                            <div class="min-w-0">
                                <p class="text-xs sm:text-sm font-medium text-westetics-neutral-900 truncate">{{ doc.document_name }}</p>
                                <p *ngIf="isDocumentSent(doc)" class="text-xs text-green-600 flex items-center gap-1">
                                    <fa-icon [icon]="faCheck"></fa-icon>
                                    Enviado para assinatura
                                </p>
                            </div>
                        </div>

                        <!-- Botões de Download -->
                        <div class="flex items-center gap-2 flex-shrink-0">
                            
                            <!-- PDF -->
                            <button 
                                (click)="onClickDownloadFile(i, doc.link_pdf || '', doc.document_name, 'pdf')"
                                [disabled]="isDownloading(i, 'pdf') || !doc.link_pdf"
                                class="px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-[#A692BA] rounded-lg hover:bg-[#A692BA]/10 transition-colors disabled:text-gray-300 disabled:cursor-not-allowed flex items-center gap-1 whitespace-nowrap"
                            >
                                <app-loading-spinner *ngIf="isDownloading(i, 'pdf')" size="sm"></app-loading-spinner>
                                <fa-icon *ngIf="!isDownloading(i, 'pdf')" [icon]="faDownload"></fa-icon>
                                <span class="hidden sm:inline">PDF</span>
                                <span class="sm:hidden">PDF</span>
                            </button>

                            <!-- DOCX -->
                            <button 
                                *ngIf="doc.link"
                                (click)="onClickDownloadFile(i, doc.link || '', doc.document_name, 'docx')"
                                [disabled]="isDownloading(i, 'docx')"
                                class="px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-1 whitespace-nowrap"
                            >
                                <app-loading-spinner *ngIf="isDownloading(i, 'docx')" size="sm"></app-loading-spinner>
                                <fa-icon *ngIf="!isDownloading(i, 'docx')" [icon]="faDownload"></fa-icon>
                                <span class="hidden sm:inline">DOCX</span>
                                <span class="sm:hidden">DOCX</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            

        </div>
    </div>

</div>

<!-- MODAL DE CONFIRMAÇÃO DE ENVIO -->
<div *ngIf="showConfirmSendModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden">
        <!-- Header do Modal -->
        <div class="bg-westetics-purple-50 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between border-b border-westetics-purple-100">
            <div class="flex items-center gap-2 sm:gap-3">
                <div class="w-8 h-8 sm:w-10 sm:h-10 bg-westetics-purple-100 rounded-full flex items-center justify-center">
                    <fa-icon [icon]="faPaperPlane" class="text-westetics-purple-700 text-sm sm:text-base"></fa-icon>
                </div>
                <h2 class="text-base sm:text-lg font-semibold text-westetics-neutral-950">Enviar para Assinatura</h2>
            </div>
            <button 
                (click)="closeConfirmSendModal()"
                class="p-2 hover:bg-westetics-purple-100 rounded-lg transition-colors"
            >
                <fa-icon [icon]="faTimes" class="text-westetics-neutral-600"></fa-icon>
            </button>
        </div>

        <!-- Conteúdo do Modal -->
        <div class="p-4 sm:p-6">
            <p class="text-xs sm:text-sm text-westetics-neutral-700 mb-3 sm:mb-4">
                Tem certeza que deseja enviar os seguintes documentos para assinatura virtual?
            </p>

            <!-- Lista de Documentos -->
            <div class="bg-gray-50 rounded-lg border border-gray-200 max-h-40 sm:max-h-48 overflow-y-auto">
                <ul class="divide-y divide-gray-200">
                    <li *ngFor="let doc of getDocumentsToSend()" class="px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2 sm:gap-3">
                        <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600 text-sm"></fa-icon>
                        <span class="text-xs sm:text-sm font-medium text-westetics-neutral-900 truncate">{{ doc.document_name }}</span>
                    </li>
                </ul>
            </div>

            <!-- Info -->
            <div class="mt-3 sm:mt-4 p-2 sm:p-3 bg-westetics-purple-400 border border-westetics-purple-500 rounded-lg">
                <p class="text-xs text-white">
                    O paciente receberá os links para assinatura dos documentos via WhatsApp.
                </p>
            </div>
        </div>

        <!-- Footer do Modal -->
        <div class="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-2 sm:gap-3">
            <button 
                (click)="closeConfirmSendModal()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border  rounded-lg  transition-colors"
            >
                Cancelar
            </button>
            <button 
                (click)="confirmSendDocuments()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white bg-westetics-purple-800 hover:bg-westetics-purple-600 rounded-lg transition-colors flex items-center gap-2"
            >
                <fa-icon [icon]="faPaperPlane"></fa-icon>
                <span class="hidden sm:inline">Confirmar Envio</span>
                <span class="sm:hidden">Enviar</span>
            </button>
        </div>
    </div>
</div>
